import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import Popup from 'components/popups/Popup'
import React from 'react'

interface OpenShopPopupProps {

}

const OpenShopPopup: React.FC<OpenShopPopupProps> = () => {
  const { t } = useTranslation('shop')
  return (
    <Popup centered>
      <div className='shopOpen__popup'>
        <div className='popup__title'>
          <div>{t('caution')}</div>
        </div>
        <div className='shopOpen__desc'>{t('driveUpToTheShopAndPressTheButton')}</div>
        <div className='shopOpen__desc'>{t('inTheShopSelectTheProductsYouNeedAndScanThem')}</div>
        <div className='shopOpen__buttons'>
          <ArrowBtn
            enlarged
            text={t('openAShop')}
            action={() => {
              alert('skaner')
            }} />
          <BackBtn
            text={t('cancel')}
          />
        </div>
      </div>
    </Popup>
  )
}

export default OpenShopPopup